import Resolution from 'engine/Resolution.js';

const cache = {};

export function getStepsInChunks(track, resolution) {
    if (track === undefined ||
        track.pattern === undefined ||
        resolution === undefined) {
        return [];
    }
    let size = resolution.transformStepAtResolution2(
        track.pattern.length(), new Resolution(32, false));
    size = Math.floor(size);

    let steps = [];
    for (let i=0; i < size; i++) {
        steps.push(i);
    }
    let stepsInRow = resolution.isTriplet ? 12 : 16;
    var numChunks = steps.length / stepsInRow;
    // a chunk is a row of steps (we only show 16 in a row);
    var stepsInChunks = [];
    for (var i=0; i < numChunks; i++) {
        var start = i*stepsInRow; 
        var end = start + stepsInRow;
        if (steps.length < end) {
            end = steps.length;
        }
        
        let key = start + ',' + end;
        if (key in cache) {
            stepsInChunks.push(cache[key]);
        } else {
            let chunk = steps.slice(start,end);
            cache[key] = chunk;
            stepsInChunks.push(chunk);
        }
    }

    return stepsInChunks;
}
